// @flow
import * as React from 'react';

import type { FormValuesShape } from 'final-form';
import { useForm } from 'react-final-form';

// native `modifiedSinceLastSubmit` state does not work well in a wizard since
// fields can be «unmounted» or unregistered and won't count when computing
// `modifiedSinceLastSubmit` state
// field unregistered: https://github.com/final-form/final-form/blob/3af52bf3d841e6f8560443597c41367dca8bca9b/src/FinalForm.js#L950
// `modifiedSinceLastSubmit` computation: https://github.com/final-form/final-form/blob/3af52bf3d841e6f8560443597c41367dca8bca9b/src/FinalForm.js#L574-L580

/**
 * This stores `modifiedSinceLastSubmit` in a state and kept when navigating
 * accross the wizard.
 */
export const useModifiedSinceLastSubmit = (): boolean => {
  const form = useForm<FormValuesShape>('useModifiedSinceLastSubmit');
  const [modified, setModified] = React.useState(false);

  React.useEffect(() => {
    return form.subscribe(
      state => {
        if (state.modifiedSinceLastSubmit) {
          setModified(true);
        }
        if (state.submitting) {
          setModified(false);
        }
      },
      { submitting: true, modifiedSinceLastSubmit: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return modified;
};
